export default "__VITE_ASSET__D4WtUAp1__"